<template>
  <div>
    <RightSidePanel
      title="Import Contacts"
      description="Create or update contacts en masse by uploading a CSV of your existing contacts"
      action="Save"
      @handleClosePanel="handleBulkCancel"
      @handleAction="createBulkContact"
    >
      <div>
        <div class="sm:hidden">
          <SelectMenu
            :initialValue="selectedTab"
            :options="['Create', 'History']"
            @selectedOption="selectedTab = $event"
          />
        </div>
        <div class="hidden sm:block">
          <nav class="flex">
            <button
              @click="selectedTab = 'Create'"
              :class="selectedTab == 'Create' ? 'bg-gray-100' : ''"
              class="px-3 py-2 font-medium text-sm leading-5 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700 focus:bg-gray-100"
            >
              Local File
            </button>
            <button
              @click="selectedTab = 'History'"
              :class="selectedTab == 'History' ? 'bg-gray-100' : ''"
              class="ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700 focus:bg-gray-100"
            >
              History
            </button>
          </nav>
        </div>
      </div>
      <BulkContactForm
        :modelValue="bulkContacts"
        @update:modelValue="updateBulkContacts"
        v-if="selectedTab == 'Create'"
      />
      <ContactCreateBulkHistory v-model="bulkContacts" v-if="selectedTab == 'History'" />
    </RightSidePanel>
  </div>
</template>

<script>
import RightSidePanel from '../shared/RightSidePanel.vue';
import BulkContactForm from './BulkContactForm.vue';
import ContactCreateBulkHistory from './ContactCreateBulkHistory.vue';
import SelectMenu from '../shared/SelectMenu.vue';

export default {
  components: {
    RightSidePanel,
    BulkContactForm,
    ContactCreateBulkHistory,
    SelectMenu,
  },
  data() {
    return {
      selectedTab: 'Create',
      bulkContacts: {
        required_keys: {
          name: '',
          email: '',
          phone: '',
          segment: '',
        },
        data: [],
      },
    };
  },
  methods: {
    updateBulkContacts(value) {
      this.bulkContacts = value;
    },
    handleBulkCancel() {
      this.$emit('cancel');
    },
    createBulkContact() {
      const self = this;
      self.$store.commit('general/showLocalLoadingSpinner');
      fetch('/api/contacts/bulk_create', {
        method: 'POST',
        body: JSON.stringify({
          contacts: self.bulkContacts,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          self.$store.commit('general/hideLocalLoadingSpinner');
          self.$emit('created');
          self.$store.commit('general/showAlert', {
            alertType: 'success',
            alertTitle: 'Bulk contacts uploaded',
            alertDescription:
              'Your contacts were successfully uploaded. It will take a few minutes for the contacts to be fully created. Use the button below dismiss this alert.',
          });
        });
    },
  },
};
</script>
